const BOLD_HOURS = ['9:00 AM', '12:00 PM', '3:00 PM'];

export const isBoldTime = (time: string) => BOLD_HOURS.includes(time);

export const getBoldTextPosition = (time: string) => {
  let position = 0;

  if (time === '9:00 AM') {
    position = -5;
  } else if (time === '12:00 PM') {
    position = -45;
  } else if (time === '3:00 PM') {
    position = -90;
  }

  return position;
};
